// extracted by mini-css-extract-plugin
module.exports = {"content-header":"ListRequestFromPortalView_content-header__3xLUK","content-header__title":"ListRequestFromPortalView_content-header__title__1HN5D"};